import React from "react";
import { observer, inject } from "mobx-react";
import Cookies from "js-cookie";
import { sendMetriks } from "Services/sendMetriks";
import Metrika from "Services/Metrika";
import { EVENT_CATEGORY_CLICK_BUTTON } from "Constants/metriks/GoogleCategorys";
import { EVENT_CLICK_COVERAGE_PROVIDER } from "Constants/metriks/GoogleActions";
import FindTariffsProviderWithPhoneContainer from "Containers/FindTariffsProviderWithPhoneContainer";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";

@inject("ApplicationModel")
@observer
export default class ProviderConnectWithPhoneHOC extends React.Component {
    openPopup(data) {
        this.closeModal();
        Metrika.getInstance().google.sendEvent(
            EVENT_CATEGORY_CLICK_BUTTON,
            EVENT_CLICK_COVERAGE_PROVIDER,
        );
        if (this.props.ratingClick) {
            Cookies.set("connectTariffFrom", "rating_from_main");
            sendMetriks("CLICK_CALLBACK_FROM_RATING_MAIN");
        }
        sendMetriks("OPEN_CALLBACK");

        let texts = this.props.ApplicationModel.text;
        let modalModel = this.props.ApplicationModel.modalModel;
        let commonViewModel = this.props.ApplicationModel.commonViewModel;
        commonViewModel.setShowFindTariffs(false);
        let promise1 = import("Layouts/modalLayout");
        Promise.all([promise1]).then(modules => {
            let ModalLayout = modules[0].default;
            commonViewModel.setShowSearchAddressPopup(true);
            modalModel.toggleModal(
                <ModalLayout
                    authView={true}
                    closeModal={() => this.closeModal()}
                    withoutClose={true}
                    fullCloseElement={true}
                    closeOnClickLayout={true}
                    onlyDesktopCloseElement={true}
                >
                    <DeclinationContainerNew>
                        <FindTariffsProviderWithPhoneContainer
                            data={data}
                            show={true}
                            text={texts}
                            onClose={() => this.closeModal()}
                            providerId={this.props.providerId}
                        />
                    </DeclinationContainerNew>
                </ModalLayout>
            );
        });
    }

    closeModal() {
        let modalModel = this.props.ApplicationModel.modalModel;
        let commonViewModel = this.props.ApplicationModel.commonViewModel;
        commonViewModel.setShowSearchAddressPopup(false);
        if (modalModel.isOpen) {
            modalModel.toggleModal();
        }
    }

    render() {
        let children = React.cloneElement(this.props.children, {
            onClick: data => this.openPopup(data),
        });
        return children;
    }
}
